import { PopperProps } from '@mui/material/Popper'
import TooltipIcon from 'ext-ui/components/TooltipIcon/TooltipIcon'
import React from 'react'
import { useSelector } from 'react-redux'
import Locked from 'src/assets/images/Locked.svg'
import Trns from 'src/localization/Trns'
import { selectActiveOrgIntegration } from 'src/redux/selectors/data/orgIntegrations.selectors'
import { css } from 'styled-components'

interface DisabledExpenseDetailsTooltipProps {
  placement: PopperProps['placement']
  integration?: string
}

const DisabledExpenseDetailsTooltip: React.FC<
  DisabledExpenseDetailsTooltipProps
> = (props): React.ReactElement => {
  const activeIntegration = useSelector(selectActiveOrgIntegration)

  return (
    <TooltipIcon
      placement={props.placement}
      icon={
        activeIntegration !== undefined ? (
          <img
            src={activeIntegration.logo}
            alt={''}
            css={css`
              width: 16px;
            `}
          />
        ) : (
          Locked
        )
      }
    >
      <p>
        {
          <>
            <Trns
              source={
                'Expense Categories for this transaction have been synced to ${orgLvlIntegration} and are uneditable.'
              }
              expressions={{
                orgLvlIntegration: (
                  <span>{activeIntegration?.platformName}</span>
                ),
              }}
            />
            <p
              css={css`
                margin-top: 16px;
              `}
            >
              <Trns
                source={
                  'Once synced, these fields can only be updated in ${orgLvlIntegration}.'
                }
                expressions={{
                  orgLvlIntegration: (
                    <span>{activeIntegration?.platformName}</span>
                  ),
                }}
              />
            </p>
          </>
        }
      </p>
    </TooltipIcon>
  )
}

export default DisabledExpenseDetailsTooltip
